// esversion: 8
import Cookies from 'js-cookie';
import Store from '../_utils/tools/store';
import { builderDispatch, WebUI } from '../_utils/ui';

const STORE_ID_COOKIE = 'assortmentStoreId';
const USER_ID_COOKIE = 'CID';
const CID_FORMAT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

async function checkForPreferences() {
  // don't bother if the cookie is already set
  if (Cookies.get(STORE_ID_COOKIE)) return;
  // crude check we're logged in and cookie value matches CID format
  if (!Cookies.get(USER_ID_COOKIE) || !CID_FORMAT.test(Cookies.get(USER_ID_COOKIE))) {
    return;
  }

   // fetch the assortmentStoreId from GraphQL endpoint
   const response = (await (await fetch("/orchestra/home/graphql/FooterLocation/177ddb14834fe8588360fba78c2af7ca1052a44f8e8721769717d189912ab8e6", {
      "headers": {
         "accept": "application/json",
         "content-type": "application/json",
         "wm_mp": "true",
         "wm_page_url": "https://www.walmart.com/",
         "x-apollo-operation-name": "FooterLocation",
         "x-o-bu": "WALMART-US",
         "x-o-ccm": "server",
         "x-o-gql-query": "query FooterLocation",
         "x-o-mart": "B2C",
         "x-o-platform": "rweb-photo",
         "x-o-platform-version": "main-496-c96289",
         "x-o-segment": "oaoh"
      },
      "method": "GET",
      "mode": "cors",
      "credentials": "include"
   })).json());

   // don't overwrite the cookie, if it's already set
   if (Cookies.get(STORE_ID_COOKIE)) return;

   if (response.data && response.data.location) {
      const { data: { location: { nodeId } } } = response;
      Cookies.set(STORE_ID_COOKIE, nodeId, { domain: '.walmart.com', path: '/' });
   }
}

if (Store.isWalmart()) {
   builderDispatch.register((event) => {
      switch (event.type) {
         case WebUI.LOGIN:
            checkForPreferences();
         break;
         default:
            // ignore;
      }
   });
   checkForPreferences();
}